(function ($) {
  // Tooltip logic + padding addition if no learn more button is present
  $('[data-toggle="tooltip"]').tooltip();
})(jQuery);
